import { render, staticRenderFns } from "./EditInquiry.vue?vue&type=template&id=149bff83&scoped=true&"
import script from "./EditInquiry.vue?vue&type=script&lang=js&"
export * from "./EditInquiry.vue?vue&type=script&lang=js&"
import style0 from "./EditInquiry.vue?vue&type=style&index=0&id=149bff83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149bff83",
  null
  
)

export default component.exports